import type { LucideIcon } from "lucide-react";
import {
  Shield,
  Clock,
  Users,
  Award,
  FileCheck,
  Headphones,
} from "lucide-react";

export type Benefit = {
  icon: LucideIcon;
  title: string;
  description: string;
};

export const benefits: Benefit[] = [
  {
    icon: Shield,
    title: "Segurança jurídica",
    description:
      "Processo conduzido pelos advogados do escritório Galvão & Silva Advocacia, com 12 anos de experiência em homologação de sentenças.",
  },
  {
    icon: Clock,
    title: "Agilidade no processo",
    description:
      "O acompanhamento contínuo, com procedimentos estruturados e precisos, que asseguram a fluidez no processo.",
  },
  {
    icon: Users,
    title: "Assessoria personalizada",
    description:
      "Atendimento que analisa cada detalhe do seu caso, oferecendo soluções jurídicas alinhadas às suas necessidades.",
  },
  {
    icon: Award,
    title: "Expertise comprovada",
    description:
      "Centenas de casos homologados com sucesso no STJ, incluindo divórcios, inventários e guarda.",
  },
  {
    icon: FileCheck,
    title: "Processo simplificado",
    description:
      "Cuidamos de toda a documentação e trâmites necessários para que você tenha tranquilidade.",
  },
  {
    icon: Headphones,
    title: "Suporte contínuo",
    description:
      "Acompanhamento em todas as etapas com comunicação transparente, atualização contínua e previsibilidade do processo.",
  },
];
